const KEY = 'caprock:drafts';

export interface IssueDraft {
  id: string;
  title: string;
  description: string;
  teamId?: string;
  updatedAt: string;
}

interface Store {
  items: IssueDraft[];
}

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { items: [] };
    const parsed = JSON.parse(raw) as Store;
    if (!Array.isArray(parsed.items)) return { items: [] };
    return parsed;
  } catch {
    return { items: [] };
  }
}

function write(store: Store) {
  localStorage.setItem(KEY, JSON.stringify(store));
  window.dispatchEvent(new Event('caprock:drafts'));
}

export function listDrafts(): IssueDraft[] {
  return read().items;
}

export function saveDraft(
  draft: Omit<IssueDraft, 'id' | 'updatedAt'> & { id?: string }
): IssueDraft {
  const next: IssueDraft = {
    id: draft.id ?? crypto.randomUUID(),
    title: draft.title,
    description: draft.description,
    teamId: draft.teamId,
    updatedAt: new Date().toISOString(),
  };
  const rest = read().items.filter((item) => item.id !== next.id);
  write({ items: [next, ...rest].slice(0, 20) });
  return next;
}

export function deleteDraft(id: string): void {
  write({ items: read().items.filter((item) => item.id !== id) });
}
